<form [formGroup]="formGroup">
  <div class="card-data">
    <h4>
      {{ "Personal Data" | translate }}
    </h4>
    <div class="row m-0">
      <div class="col-12 col-sm-6">
        <label>{{ "Full Name" | translate }}</label>
        <input
          type="text"
          placeholder="{{ 'Enter your Full Name' | translate }}"
          formControlName="name"
        />
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Phone Number" | translate }}</label>

        <input
          type="text"
          placeholder="{{ 'Enter your phone number' | translate }}"
          formControlName="phone"
        />
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Email" | translate }}</label>

        <input
          type="text"
          placeholder="{{ 'Enter your email' | translate }}"
          formControlName="email"
        />
      </div>

      <div class="col-12 col-sm-6">
        <label>{{ "Country" | translate }}</label>

        <input
          type="text"
          placeholder="{{ 'Enter your country' | translate }}"
          formControlName="country"
        />
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "City" | translate }}</label>

        <input
          type="text"
          placeholder="{{ 'Enter your city' | translate }}"
          formControlName="city"
        />
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "LinkedIn" | translate }}</label>

        <input
          type="text"
          placeholder="{{ 'Enter your LinkedIn' | translate }}"
          formControlName="linkedIn"
        />
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Job title" | translate }}</label>

        <input
          type="text"
          placeholder="{{ 'Enter your job title' | translate }}"
          formControlName="title"
        />
      </div>

      <div class="col-12">
        <label>{{ "Objective" | translate }}</label>

        <textarea
          type="text"
          placeholder="{{ 'Enter your objective' | translate }}"
          formControlName="summary"
        ></textarea>
      </div>
    </div>
    <!-- <h6 class="mt-3">
      {{ "Add more information about you" | translate }}
      {{ "optional" | translate }}
    </h6>

    <div class="d-flex flex-wrap">
      <button class="border-button">
        {{ "LinkedIn" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>
      <button class="border-button">
        {{ "Behance" | translate }}
        <i class="bi bi-plus-lg"></i></button
      ><button class="border-button">
        {{ "GitHub" | translate }}
        <i class="bi bi-plus-lg"></i></button
      ><button class="border-button">
        {{ "Website" | translate }}
        <i class="bi bi-plus-lg"></i></button
      ><button class="border-button">
        {{ "Driving license" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>
    </div> -->
  </div>

  <div class="next-container px-4">
    <button class="border-button m-3" (click)="onPrevious()">
      {{ "Back" | translate }}
    </button>
    <button class="gradient-button m-3" (click)="onNext()">
      {{ "Next" | translate }}
    </button>
  </div>
</form>
